<template>
  
  <div id="modal-ter" class="modal " :class="{'is-active': showModal}" >
      
      <div class="modal-background"></div>
        <div class="modal-card" >
          <header class="modal-card-head">
            <p class="modal-card-title">{{ order.ponumber }} / {{ order.status }} </p>
            <button class="delete" aria-label="close" @click="closeModal()"></button>
          </header>
          <section class="modal-card-body">
            <div class="content" ref="content">
              <img v-bind:src="'/assets/img/' + order.garmentimage" />
              <h3 >Order Details</h3>
              <div class=" columns ">
                  <div class="column is-4">
                      Client Name
                    </div>
                    <div class="column is-8">
                      {{ order.clientname }}
                      </div>
                </div>
                <div class=" columns">
                  <div class="column is-4">
                      Forecast Delivery
                    </div>
                    <div class="column is-8">
                      {{ order.orderDate }}
                      </div>
                </div>
                <div class=" columns">
                  <div class="column is-4">
                      Garment
                    </div>
                    <div class="column is-8">
                      {{ order.garmentname }}
                      </div>
                </div>
                <div class=" columns">
                  <div class="column is-4">
                      Design Name
                    </div>
                    <div class="column is-8">
                      Slaughtneil Noones Green/White 2019
                      </div>
                </div>

                <h3 >Outfield Jersey Details</h3>
                <div class=" columns">
                  <div class="column is-4">
                      Jersey Pattern
                    </div>
                    <div class="column is-8">
                      Max Stretch Gaelic - Club Fit
                      </div>
                </div>
                 <div class=" columns">
                  <div class="column is-4">
                      Licenced Logo
                    </div>
                    <div class="column is-8">
                      New GAA
                      </div>
                </div>
                <div class=" columns">
                  <div class="column is-4">
                      Sleeve Type
                    </div>
                    <div class="column is-8">
                     Set-In
                      </div>
                </div>
                 <div class=" columns">
                  <div class="column is-4">
                      Sleeve Style
                    </div>
                    <div class="column is-8">
                     Short Sleeve
                      </div>
                </div>

                <h3 >Additional Production Info</h3>
                <div class=" columns">
                  <div class="column is-4">
                      Jersey Fit
                    </div>
                    <div class="column is-8">
                      Tight Fit
                      </div>
                </div>
              
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" @click="downloadPDF()">Download PDF</button>
            <button class="button" @click="closeModal()">Close</button>
          </footer>
        </div>
        
    </div>

</template>

<script>
import OneOrder1 from '@/data/OneOrder1.js'
import OneOrder2 from '@/data/OneOrder2.js'


export default {
  data() {
    return {
      order: []
    }
  },
  props: {
    showModal: Boolean,
    orderID: Number
  },
  
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
		getOrder() {
      if(this.orderID === 1)
      {
        this.order = OneOrder1
      }
      else{
        this.order = OneOrder2
      }
    },
    downloadPDF() {
      window.open("https://www.oneillsonline.com/temp/sample.pdf", "_blank");    
   
    }
  },
  created() {
    const onEscape = (e) => {
      if (this.showModal && e.keyCode === 27) {
        this.closeModal()
      }
    }
    document.addEventListener('keydown', onEscape)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', onEscape)
    })
  },
  mounted() {
    this.getOrder()
  },
  watch: {
    'orderID'() {
      this.getOrder()
    }
  }
  

}
</script>

<style scoped>
  .column {padding-top:0;padding-bottom:0px}
  h3 {margin-top:10px !important}

</style>